import store from '@/common_store'
import { heartbeat } from '@/SZGZ/api/index'
export function parseTime(time, cFormat) {
  // console.log(time)
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/ig) != null) {
      len += 1
    } else {
      len += 0.5
    }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined) return ''
    return encodeURIComponent(key) + '=' +
      encodeURIComponent(json[key])
  })).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  for (const property in source) {
    if (source.hasOwnProperty(property)) {
      const sourceProperty = source[property]
      if (typeof sourceProperty === 'object') {
        target[property] = objectMerge(target[property], sourceProperty)
        continue
      }
      target[property] = sourceProperty
    }
  }
  return target
}

export function scrollTo(element, to, duration) {
  if (duration <= 0) return
  const difference = to - element.scrollTop
  const perTick = difference / duration * 10
  setTimeout(() => {
    // console.log(new Date())
    element.scrollTop = element.scrollTop + perTick
    if (element.scrollTop === to) return
    scrollTo(element, to, duration - 10)
  }, 10)
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [{
  text: '今天',
  onClick(picker) {
    const end = new Date()
    const start = new Date(new Date().toDateString())
    end.setTime(start.getTime())
    picker.$emit('pick', [start, end])
  }
}, {
  text: '最近一周',
  onClick(picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
    picker.$emit('pick', [start, end])
  }
}, {
  text: '最近一个月',
  onClick(picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    picker.$emit('pick', [start, end])
  }
}, {
  text: '最近三个月',
  onClick(picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
    picker.$emit('pick', [start, end])
  }
}]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  for (const keys in source) {
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = source[keys].constructor === Array ? [] : {}
        targetObj[keys] = deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    }
  }
  return targetObj
}

export function selectionformatter(arr) {
  let result = []
  if (arr instanceof Array) {
    arr.forEach(item => {
      result.push({
        value: item.id,
        label: item.id
      })
    })
  }
  return result
}

export function getLocalLanguage() {
  return store.state.app.language
}

export function getLocalDimesion() {
  return store.state.app.dimension
}

export function add(m) {
  return m < 10 ? '0' + m : m
}
export function getLocalTime(ns) {
  var time = new Date(ns)
  var y = time.getFullYear()
  var m = time.getMonth() + 1
  var d = time.getDate()
  var h = time.getHours()
  var mm = time.getMinutes()
  var s = time.getSeconds()
  return y + '-' + add(m) + '-' + add(d) + ' ' + add(h) + ':' + add(mm) + ':' + add(s)
}

export function formatterYCData(res) {
  let data = [].concat(res)

  // =============================图片颜色未处理

  // 加载图片资源，待定

  let images = {}
  let pattern = ''
  data.forEach((item, index) => {
    if (!images[item.zyysmc]) {
      if (item.zyysmc) {
        images[item.zyysmc] = new Image()
        images[item.zyysmc].onload = () => {
          pattern = new geotoolkit.attributes.ImageContainer('patterns')
          pattern.register(item.zyysmc, images[item.zyysmc])
        }

        images[item.zyysmc].src = item.rockCode
        images[item.zyysmc].name = item.zyysmc.toString() || ''
        images[item.zyysmc].onload()
      }
    }
  })
  //-----------------------


  data.sort(function (a, b) {
    return a.djsd2 - b.djsd2
  })
  const depths = []
  const fillStyles = []
  const names = []
  data.forEach((item, index) => {
    if (index === 0) {
      depths.push(item.djsd1)
      depths.push(item.djsd2)
    } else {
      depths.push(item.djsd2)
    }
    let r = Math.floor(Math.random() * 156) + 100;
    let g = Math.floor(Math.random() * 156) + 100;
    let b = Math.floor(Math.random() * 156) + 100;
    let color = '#' + r.toString(16) + g.toString(16) + b.toString(16)
    fillStyles.push(
      new geotoolkit.attributes.FillStyle(item.colorValue || color, item.zyysmc ? pattern.queryPattern(item.zyysmc) : null)
    )
    // fillStyles.push()
    names.push(item.dcmc)
  })

  return {
    depths,
    fillStyles,
    names
  }
}
export function formatterYCDataForMeter(res) {
  let data = [].concat(res)

  // =============================图片颜色未处理

  // 加载图片资源，待定

  let images = {}
  let pattern = ''
  data.forEach((item, index) => {
    if (!images[item.ysmc]) {
      if (item.ysmc) {
        images[item.ysmc] = new Image()
        images[item.ysmc].onload = () => {
          pattern = new geotoolkit.attributes.ImageContainer('patterns')
          pattern.register(item.ysmc, images[item.ysmc])
        }

        images[item.ysmc].src = item.rockCode
        images[item.ysmc].name = item.ysmc.toString() || ''
        images[item.ysmc].onload()
      }
    }
  })
  //-----------------------


  data.sort(function (a, b) {
    return a.djsd2 - b.djsd2
  })
  const depths = []
  const fillStyles = []
  const names = []
  const logValue = []
  data.forEach((item, index) => {
    if (index === 0) {
      depths.push(item.djsd1)
      depths.push(item.djsd2)
    } else {
      depths.push(item.djsd2)
    }
    let r = Math.floor(Math.random() * 256);
    let g = Math.floor(Math.random() * 256);
    let b = Math.floor(Math.random() * 256);
    let color = '#' + r.toString(16) + g.toString(16) + b.toString(16)
    fillStyles.push(
      new geotoolkit.attributes.FillStyle(colorRGBtoHex(item.ysdm), item.ysmc ? pattern.queryPattern(item.ysmc) : null)
    )
    logValue.push(item.constRockLength ? Number(item.constRockLength) : 20)
    // fillStyles.push()
    // names.push(item.ysmc)
  })

  return {
    depths,
    fillStyles,
    names,
    logValue
  }
}
function colorRGBtoHex(color) {
  if (!color) return '#fff'
  var rgb = color.split(',');
  var r = parseInt(rgb[0].split('(')[1]);
  var g = parseInt(rgb[1]);
  var b = parseInt(rgb[2].split(')')[0]);
  var hex = "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  return hex;
}
export function changeTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}
export function formatterBoreData(boreData) {
  let data = []
  boreData.forEach(item => {
    data.push({
      name: item.name,
      describtion: item.data.description,
      fromDepth: item.data.geometry.depth.from || 0,
      toDepth: item.data.geometry.depth.to || null,
      outer: item.data.geometry.diameter.outer || null,
      inner: item.data.geometry.diameter.inner || null
    })
  })

  return data
}

export function openheartbeat(time = 900000) {
  if (window._heartbeatTimer) {
    window.clearInterval(window._heartbeatTimer)
    window._heartbeatTimer = null
    window._heartbeatTimer = setInterval(() => {
      heartbeat()
    }, time)
  } else {
    window._heartbeatTimer = setInterval(() => {
      heartbeat()
    }, time)
  }
}
